module.exports = __webpack_public_path__ + "static/media/greenplumdb.7bd150d2.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/icons/greenplumdb.png
// module id = 106
// module chunks = 0